import React from 'react';
import { SectionCard, TextField, TextAreaField, NumberField, Repeater } from '../../../components/admin/EditorFields';

export default function LocationsEditor({ data, setData }) {
  const upd = (path, value) => setData((d) => {
    const next = JSON.parse(JSON.stringify(d));
    const keys = path.split('.');
    let cur = next;
    for (let i = 0; i < keys.length - 1; i++) {
      cur[keys[i]] = cur[keys[i]] || {};
      cur = cur[keys[i]];
    }
    cur[keys[keys.length - 1]] = value;
    return next;
  });

  return (
    <div className="space-y-5">
      <SectionCard title="En-tête de la page">
        <TextField label="Eyebrow" value={data.hero?.eyebrow} onChange={(v) => upd('hero.eyebrow', v)} />
        <div className="grid sm:grid-cols-2 gap-3">
          <TextField label="Titre" value={data.hero?.title} onChange={(v) => upd('hero.title', v)} />
          <TextField label="Titre en couleur" value={data.hero?.titleHighlight} onChange={(v) => upd('hero.titleHighlight', v)} />
        </div>
        <TextAreaField label="Description" rows={3} value={data.hero?.description} onChange={(v) => upd('hero.description', v)} />
      </SectionCard>

      <SectionCard title="Liste des kiosques" description="x/y sont des coordonnées en pourcentage sur la carte stylisée (0-100). Statut: active, planned ou study.">
        <Repeater
          items={data.items}
          onChange={(items) => setData((d) => ({ ...d, items }))}
          newItem={() => ({ name: '', city: '', region: '', status: 'study', x: 50, y: 50, openingDate: 'À l\'étude', dailyUsers: 0, type: 'Plate' })}
          addLabel="Ajouter un kiosque"
          renderItem={(item, update) => (
            <div className="space-y-3">
              <div className="grid sm:grid-cols-3 gap-3">
                <TextField label="Nom" value={item.name} onChange={(v) => update({ name: v })} />
                <TextField label="Ville" value={item.city} onChange={(v) => update({ city: v })} />
                <TextField label="Région" value={item.region} onChange={(v) => update({ region: v })} />
              </div>
              <div className="grid sm:grid-cols-4 gap-3">
                <div>
                  <label className="text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5 block">Statut</label>
                  <select value={item.status || 'study'} onChange={(e) => update({ status: e.target.value })} className="w-full h-11 rounded-xl border border-sky-200 px-3 text-sm">
                    <option value="active">Actif</option>
                    <option value="planned">En projet</option>
                    <option value="study">À l'étude</option>
                  </select>
                </div>
                <NumberField label="Position X (0-100)" value={item.x} onChange={(v) => update({ x: v })} step={1} />
                <NumberField label="Position Y (0-100)" value={item.y} onChange={(v) => update({ y: v })} step={1} />
                <NumberField label="Utilisateurs/jour" value={item.dailyUsers} onChange={(v) => update({ dailyUsers: v })} />
              </div>
              <div className="grid sm:grid-cols-2 gap-3">
                <TextField label="Date d'ouverture" value={item.openingDate} onChange={(v) => update({ openingDate: v })} />
                <TextField label="Type d'eau" value={item.type} onChange={(v) => update({ type: v })} />
              </div>
            </div>
          )}
        />
      </SectionCard>

      <SectionCard title="Bloc « Votre commune souhaite un kiosque ? »">
        <TextField label="Titre" value={data.communeBlock?.title} onChange={(v) => upd('communeBlock.title', v)} />
        <TextAreaField label="Description" rows={3} value={data.communeBlock?.description} onChange={(v) => upd('communeBlock.description', v)} />
        <TextField label="Libellé du CTA" value={data.communeBlock?.ctaLabel} onChange={(v) => upd('communeBlock.ctaLabel', v)} />
      </SectionCard>
    </div>
  );
}
